import { render } from "./employee-salary-modal.vue?vue&type=template&id=53751939"
import script from "./employee-salary-modal.vue?vue&type=script&lang=js"
export * from "./employee-salary-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__